'use strict';

export default function ResponsiveVids() {
  function _debounce(func, wait, immediate) {  
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function resizeVideos() {
    var ASPECT_RATIO = 9/16; // 16:9
    var isVideo = /(youtube)|(vimeo)/i;
    
    $("iframe").filter(function() {
      return isVideo.test($(this).attr('src'));
    }).each(function() {
      var newWidth     = $(this).parent().width();
      var newHeight    = (ASPECT_RATIO * newWidth);

      $(this).attr('width', newWidth.toString());
      $(this).attr('height', newHeight.toString());
    });
  }

  $(document).ready(function() {
    resizeVideos();

    $(window).resize(_debounce(resizeVideos, 70));
  });
};